import { render, staticRenderFns } from "./RiderSideBar.vue?vue&type=template&id=5272b934"
import script from "./RiderSideBar.vue?vue&type=script&lang=js"
export * from "./RiderSideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports